import { toast } from "react-toastify";

export async function handleCep(cep, setAddress) {
  if (cep) {
    var cepFormat = cep.replace(/[^0-9]/g, "");

    if (cepFormat.length === 8) {
      const notification = toast.loading("Por favor aguarde...");

      try {
        const response = await fetch(`https://viacep.com.br/ws/${cepFormat}/json/`);
        const data = await response.json();
        if (data.erro) {
          throw new Error("CEP não encontrado!");
        }

        const address = {
          cep: data.cep,
          address: data.logradouro,
          neighborhood: data.bairro,
          city: data.localidade,
          state: data.uf,
        };

        setAddress(address);
        document.querySelector('input[name="num"]').focus();

        toast.update(notification, {
          render: "CEP encontrado com sucesso!",
          autoClose: 1000,
          theme: "colored",
          type: "success",
          isLoading: false,
        });
      } catch (error) {
        toast.update(notification, {
          render: error.message || "Erro ao buscar CEP!",
          autoClose: 1000,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
      }
    }
  }
}